import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useTiersQuery = createQueryHook(MembershipsCreatorV2ApiClient.getTiers, {
  queryKey: ['tiers'],
})
